import { ErrorResponse } from '@src/interface/api/response.interface'
import { signup, SignupResponse } from '@src/lib/api/auth/signup'
import { useMutation, UseMutationResult } from '@tanstack/react-query'
import { AxiosError } from 'axios'

const useSignupQuery = (): UseMutationResult<
	SignupResponse,
	AxiosError<ErrorResponse>,
	{
		username: string
		password: string
	}
> => {
	return useMutation(({ username, password }) =>
		signup({
			username,
			password,
		}),
	)
}

export default useSignupQuery
